export const MODAL_NAMES = {
  BACK_UP_INSURANCE_MODAL: 'back-up-insurance-modal',
  BACK_UP_PLUS_INSURANCE_MODAL: 'back-up-plus-insurance-modal',
}

export const DEFAULT_INSURANCE_ID = '0'
